<template>
  <form @submit.prevent="submitForm">
    <!-- Sprachlevel -->
    <div class="row">
      <h6 class="mb-2 text-uppercase pl-3">beiMigrationshintergrund: Sprachniveau Deutsch</h6>
    </div>
    <div class="row ml-3">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.a1Beginner"
                      label="A1 Beginner" labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.a1BeginnerPrevKnowledge"
                      label="A1 Beginner (mit Vorkenntnissen)"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.b1Intermediate"
                      label="B1 Intermediate"
                      labelPosition="right"/>
      </div>
    </div>
    <div class="row ml-3 mt-1">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.b2Advanced"
                      label="B2 Intermediate"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.languageLevelC1AndBetter"
                      label="C1 und besser"
                      labelPosition="right"/>

      </div>
    </div>

    <!-- Schulabschluss -->
    <div class="row mt-4">
      <h6 class="mb-2 text-uppercase pl-3">Schulabschluss:</h6>
    </div>
    <div class="row ml-3">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.graduationSecondarySchools"
                      label="Hauptschule"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.graduationSecondarySchools2"
                      label="Realschule"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.graduationHighSchoolDiploma"
                      label="Abitur"
                      labelPosition="right"/>
      </div>
    </div>
    <div class="row ml-3">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.graduationOther"
                      label="Sonstige"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.graduationWithoutDegree"
                      label="Ohne Abschluss"
                      labelPosition="right"/>
      </div>
    </div>

    <!-- Berufsausbildung -->
    <div class="row mt-4">
      <h6 class="mb-2 text-uppercase pl-3">Abgeschlossene Berufsausbildung/Studium:</h6>
    </div>
    <div class="row ml-3">
      <div class="col-lg-1 col-md-2 col-sm-3">
        <BaseCheckbox v-model="formData.completedVocationalTrainingYes"
                      label="Ja"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-11 col-md-10 col-sm-9">
        <input type="text" v-model="formData.jobTitle" placeholder="Jobtitel" class="form-control"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.completedVocationalTrainingNo"
                      label="Nein"
                      labelPosition="right"/>
      </div>
    </div>

    <!-- Maßnahme -->
    <div class="row mt-4">
      <h6 class="mb-2 text-uppercase pl-3">Welche Maßnahme:</h6>
    </div>
    <div class="row ml-3">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.fcOperationType"
                      label="FC"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.micOperationType"
                      label="MIC"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.compassOperationType"
                      label="KOMPASS"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.goWorkOperationType"
                      label="GoArbeit"
                      labelPosition="right"/>
      </div>
    </div>
    <div class="row ml-3 mt-2">
      <div class="col-lg-2 col-md-4 col-sm-12">
        <BaseCheckbox v-model="formData.othersOperationType"
                      label="Andere"
                      labelPosition="right"
                      @update:modelValue="onChangeOthersOperationType"/>
      </div>
      <div class="col-lg-10 col-md-8 col-sm-12">
        <BaseInput v-model="formData.othersOperationTypeDescription"
                   label="Beschreibung"
                   :disabled="otherOperationTypeDisabled"
                   :validation="v$?.othersOperationTypeDescription"
                   :messages="v$?.othersOperationTypeDescription?.required?.$message"/>
      </div>
    </div>

    <!-- Fachcoaching -->
    <div class="row mt-4">
      <h6 class="mb-2 text-uppercase pl-3">Welches Fachcoaching:</h6>
    </div>
    <div class="row ml-3">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.specialistCoachingPsychologically"
                      label="Psychologisch"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.specialistCoachingHealthWise"
                      label="Gesundheitlich"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.specialistCoachingSocial"
                      label="Sozial"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.specialistCoachingProfessionally"
                      label="Beruflich"
                      labelPosition="right"/>
      </div>
    </div>

    <!-- Digitale Kompetenz -->
    <div class="row mt-4">
      <h6 class="mb-2 text-uppercase pl-3">Digitale Kompetenz/Endgeräte:</h6>
    </div>
    <div class="row ml-3">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.digitalCompetenceSmartphone"
                      label="Smartphone"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.digitalCompetenceLaptopPc"
                      label="Laptop/PC"
                      labelPosition="right"/>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <BaseCheckbox v-model="formData.digitalCompetenceNoDeviceAvailable"
                      label="Kein Gerät"
                      labelPosition="right"/>
      </div>
    </div>

    <!-- Submit -->
    <div class="row mt-5 text-center">
      <div class="col-12">
        <SaveButton
            :label="$t('general.button.save')"
            :loading="isSubmitting"/>
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import { computed, defineEmits, defineProps, onMounted, ref, toRefs } from 'vue';
import BaseCheckbox from '@/components/base/BaseCheckbox.vue';
import BaseInput from '@/components/base/BaseInput.vue';
import { requiredRule } from '@/shared/validators/validationRules';
import useVuelidate from '@vuelidate/core';
import { useI18n } from 'vue-i18n';
import unemployedPrivateCoachingService from '@/api/Unemployed/PrivateCoaching/index';
import { ErrorToast, SuccessToast } from '@/components/VueToast';
import SaveButton from '@/components/button/SaveButton.vue';

const props = defineProps({
  documentId: {
    type: String,
    required: true,
  },
  submitForm: {
    type: Boolean,
    required: true,
    default: false,
  },
});

const documentId = toRefs(props)['documentId'];
const { t } = useI18n();
const otherOperationTypeDisabled = ref(true);
const isSubmitting = ref(false);

const emit = defineEmits(['update:submitForm']);

const formData = ref<any>({
  a1Beginner: false,
  a1BeginnerPrevKnowledge: false,
  b1Intermediate: false,
  b2Advanced: false,
  languageLevelC1AndBetter: false,

  graduationSecondarySchools: false,
  graduationSecondarySchools2: false,
  graduationHighSchoolDiploma: false,
  graduationOther: false,
  graduationWithoutDegree: false,

  completedVocationalTrainingYes: false,
  jobTitle: '',
  completedVocationalTrainingNo: false,

  fcOperationType: false,
  micOperationType: false,
  compassOperationType: false,
  goWorkOperationType: false,
  othersOperationType: false,
  othersOperationTypeDescription: '',

  specialistCoachingPsychologically: false,
  specialistCoachingHealthWise: false,
  specialistCoachingSocial: false,
  specialistCoachingProfessionally: false,

  digitalCompetenceSmartphone: false,
  digitalCompetenceLaptopPc: false,
  digitalCompetenceNoDeviceAvailable: false,
});

const rules = ref({});
const computedRules = computed(() => rules.value);
const v$ = useVuelidate(computedRules, formData);

async function submitForm() {
  v$.value.$touch();
  if (v$.value.$invalid) {
    return;
  }

  try {
    await unemployedPrivateCoachingService.saveSelectionInterview(documentId.value, formData.value);

    isSubmitting.value = false;
    emit('update:submitForm', !props.submitForm);
    SuccessToast(t('general.toasts.save_success'));
  } catch (error) {
    await ErrorToast(error);
  } finally {
    isSubmitting.value = false;
  }
}

async function getDocumentData() {
  try {
    const { data } = await unemployedPrivateCoachingService.getSelectionInterview(documentId.value);
    formData.value = { ...data.data};
  } catch (error) {
    await ErrorToast(error);
  }
}

function onChangeOthersOperationType(value: boolean) {
  formData.value.othersOperationTypeDescription = '';
  if (value) {
    rules.value = {
      ...rules.value,
      othersOperationTypeDescription: requiredRule(t)
    };
    otherOperationTypeDisabled.value = false;
  } else {
    rules.value = {
      ...rules.value,
      othersOperationTypeDescription: '',
    };
    otherOperationTypeDisabled.value = true;
  }
}

onMounted(async () => {
  await getDocumentData();
});
</script>

